import { Badge, Button } from "react-bootstrap";
import { X } from "react-bootstrap-icons";
import { WarehouseName } from "../WarehouseComponents/WarehouseName";

interface FilterTagProps {
  warehouseId?: string;
  onRemove: () => void;
}

export const FilterTag = ({ warehouseId, onRemove }: FilterTagProps) => {
  if (!warehouseId) return null;
  return (
    <Badge bg="primary" className="d-flex align-items-center gap-1 p-2">
      <span>Warehouse: <WarehouseName warehouseId={warehouseId} /></span>
      <Button
        variant="link"
        size="sm"
        className="p-0 text-white"
        onClick={onRemove}
      >
        <X size={14} />
      </Button>
    </Badge>
  );
};